
export const SET_MATCHES = 'SET_MATCHES';

export const MATCH_LOGOUT='MATCH_LOGOUT';
